$(document).ready(function(){
    var trustedReviews = document.querySelectorAll('.block__trusted-brands-review-slider')
    trustedReviews && trustedReviews.forEach(trustedReviewsAll => {
            new Swiper(trustedReviewsAll, {
                slidesPerView: 1,
                spaceBetween: 10,
                loop: true,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: true,
                },
                breakpoints: {
                    420: {
                      slidesPerView: 1
                    }
                }
            });
        });

    if ($(window).width() <= 749){
        var trustedBrands = document.querySelectorAll('.block__trusted-brands-logos-slider')
        trustedBrands && trustedBrands.forEach(trustedBrandsAll => {
            new Swiper(trustedBrandsAll, {
                slidesPerView: 2.5,
                spaceBetween: 34,
                centeredSlides: true,
                loop: true,
                breakpoints: {
                    420: {
                      slidesPerView: 3.9
                    }
                }
            });
        });
    }
});